/**
 * Created by kongwm.kong on 2017/7/19.
 * 修改默认的required的提示信息   以及自定义的required的提示信息  分开写  email  等是 input name的值
 */
const dict = {
  zh_CN: {
    custom: {
      digits: {
        required: '请输入纯数字'  // messages can be strings as well.
      },
      vipName: {
        required: '请输入用户名'  // messages can be strings as well.
      },
      email: {
        required: '请输入邮箱地址'  // messages can be strings as well.
      },
      prePass: {
        required: '请输入原密码'
      },
      newPass: {
        required: '请输入新密码'
      },
      name: {
        required: () => '请输入用户名'
      },
      username: { //登录的用户提示
        required: () => '请输入用户名／手机号／公司全称'  // messages can be strings as well.
      },
      username1: {
        required: () => '请输入用户名／手机号'  // messages can be strings as well.
      },
      password: {
        required: '请输入密码'
      },
      password1: {
        required: '请再次输入密码'
      },
      validImg: {
        required: '请输入图形验证码'
      },
      validCode: {
        required: '请输入手机验证码'
      },
      greenBox: {
        required: '请通阅读并同意《金斧子服务协议》'
      },
      mobile: {
        required: '请输入手机号码'
      },
      /*公司详情*/
      companyIntro: {
        required: '请输入公司简介'
      },
      privateInvestIdea: {
        required: '请输入投资理念'
      },
      companyFullName: {
        required: '请输入公司全称'
      },
      paidCapitalStart: {
        required: '请输入实缴资金'
      },
      privateBaseCurrencyUnit: {
        required: '请输入注册资金'
      },
      companyName: {
        required: '请输入公司简称'
      },
      englishName: {
        required: '请输入公司英文名称'
      },
      companyNature: {
        required: '请输入企业性质'
      },
      companyAddress: {
        required: '请输入办公地址'
      },
      privateRegisterNumber: {
        required: '请输入登记编号'
      },
      companyUrl: {
        required: '请输入公司网址'
      },
      /*基金详情*/
      simuTrustBankName: {
        required: '请输入托管机构名称'
      },
      investmentScope: {
        required: '请说明投资范围'
      },
      prdFullName: {
        required: '请输入基金全称'
      },
      prdDisCate: {
        required: '请输入产品发型类别'
      },
      issueScale: {
        required: '请输入发行规模'
      },
      investConsultant: {
        required: '请输入投资顾问'
      },
      investmentLimit: {
        required: '请输入起购金额'
      },
      performanceFeesProportion: {
        required: '请输入业绩报酬计提比例'
      },
      simuFeeRedem: {
        required: '请输入赎回费率'
      },
      registerDate: {
        required: '请选择备案日期'
      },
      registerNumber: {
        required: '请填写备案号码'
      },
      prdIssueCompanyCode: {
        required: '请输入基金管理人'
      },
      initialUnitValue: {
        required: '请输入单位面值'
      },
      minCapRemark: {
        required: '请输入追加起点'
      },
      simuFeePurch: {
        required: '请输入认购费率'
      },
      simuFeeFixed: {
        required: '请输入管理费率'
      },
      simuCloseDate: {
        required: '请输入封闭月'
      },
      /*净值详情*/
      prdShortName: {
        required: '请输入基金简称'
      },
      unitNet: {
        required: '请输入单位净值'
      },
      accountNet: {
        required: '请输入净值,如：1.2343'
      },
      facNet: {
        required: '请输入复权累计净值,如：1.2343'
      },
      /*基金经理*/
      managerName: {
        required: '请输入姓名'
      },
      startYear: {
        required: '请输入从业起始年份'
      },
      college: {
        required: '请输入毕业院校'
      },
      major: {
        required: '请输入主修专业'
      },
      investmentStyle: {
        required: '请输入投资风格'
      },
      position: {
        required: '请输入职位'
      },
      resume: {
        required: '请输入个人简介'
      }

    }
    // custom: field =>  '请输入'+field
  }
};
export default dict;


// WEBPACK FOOTER //
// ./src/config/dict.js